



































































import { Component, Prop, Vue } from 'vue-property-decorator';

export enum NotificationMethod {
  sms = 'sms'
}

export interface HealthCheckConfig {
  pingFreq: number;
  alarmNotification: NewAlarmNotificationDefinition;
}

export interface NewAlarmNotificationDefinition {
  waitTime: number;
  subscriptions: Array<Subscription>;
}

export interface Subscription {
  order: number;
  method: NotificationMethod;
  address: string;
  name: string;
  message: string;
}

export interface HealthCheckConfig {
  pingFreq: number;
  AlarmNotification: NewAlarmNotification;
}

export interface NewAlarmNotification {
  // controller: number;
  // alarm: number;
  waitTime: number;
  notification: Notification;
  subscriptions: Array<Subscription>;
}

export interface Subscription {
  subscriber: {
    id: string;
    name: string;
  };
  order: number;
  notification: {
    method: NotificationMethod;
    address: string;
  };
}

@Component
export default class HealthCheckConfigView extends Vue {
  // configuration: HealthCheckConfig;

  constructor() {
    super();
  }
}
